import type { ExtensionApi } from './extension';
import { View } from './View';
import type { NormalLayer, NormalLayerSpec } from './layer';
import { getLayer } from '../layer';
import NormalSpecProcessor from '../dataProcessor/processors/NormalSpecProcessor';

export interface Spec {
  /** 图层，类似 echarts 中的 series 概念，但比 series 抽象程度更高 */
  layers: NormalLayerSpec[];
}

export class NormalView extends View {
  private __destroyFunc!: () => void;

  render(api: ExtensionApi, $container: HTMLElement, spec: Spec) {
    const globalLayoutInfo = api.hook.layout(api);
    const { layers = [] } = spec;

    if (globalLayoutInfo.mainView.hasIndependentLayer && layers.length > 1) {
      throw new Error('Multiple `independent` layers are not supported.');
    }

    const layer = layers[0];
    const layerDefine = getLayer(layer.type) as NormalLayer;

    this.__destroyFunc = layerDefine.render(api, layer, $container);
  }

  // eslint-disable-next-line class-methods-use-this
  preprocessing(api: ExtensionApi, spec: Spec) {
    const { data } = api;
    const isValid = NormalSpecProcessor.preprocessing(data, spec);
    if (!isValid) {
      console.error('Invalid spec');
    }
  }

  destroy() {
    this?.__destroyFunc?.();
  }
}
